import graphql from "babel-plugin-relay/macro";

const allOrganizationsDropdown = graphql`
    fragment OrganizationsFragments_AllOrganizationsDropdown on Organization @relay(plural: true) {
        id,
        primaryName
    }
`

export default allOrganizationsDropdown